import axiosConfig from "./axiosConfig";

interface HhDataConfig {
  config?: any;
}

const getHhDataConfig = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataConfig> => {
  const { data } = await axiosConfig.get(`/hh_data/${fileGuid}/config`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getHhDataConfig;
